import store from '@/store'
import * as apiPayment from '@/api/payment'
import * as apiContract from '@/api/contract'

/**
 * WEB会員認証して、OKであれば次の画面に遷移する
 * @param context コンテキスト
 * @param group1 group1オブジェクト
 * @param check WEB会員認証APIのリクエストパラメータcheckの値(1=データ保存しない、2=データ保存する)
 *
 */
export const authWebUserIDAndGoToNextWindow = (context, group1, check) => {

  // ストアに保持
  store.dispatch('contract/setSettlementType', group1.settlementType)
  if (group1.settlementType === 1) {
    store.dispatch('contract/setPaymentType', group1.paymentType)
  }
  store.dispatch('contract/setWebUserId', group1.webuser_id)
  store.dispatch('contract/setRequestCode', group1.request_code)

  const identificationCode = store.state.profile.identification_code

  // WEB会員認証APIをコール
  const params = {
    webuser_id: group1.webuser_id, // WEB会員ID
    identification_code: identificationCode, // 契約識別コード
    settlement_type: group1.settlementType, // 決済方法（1=クレカ、2=口座振替、9=WEB請求書）
    request_code: group1.request_code, // お申込みコード
    check: check
  }

  // 支払い方法（1=一括　2=分割）
  if (group1.settlementType === 1) {
    // クレジットカードの場合
    params.payment_type = group1.paymentType
  }

  store.dispatch('common/showLoading')

  apiPayment.authenticateWebMember(params)
    .then(response => {
      if (response) {
        const { data } = response

        const status = data.status
        const errorMessage = data.error_message

        if (status === 0) {
          // WEB会員認証OKの場合

          // 自動決済認証(確認)画面を表示する
          context.emit('goToNextWindow')

        } else {
          // WEB会員認証NGの場合
          // エラーメッセージを表示する
          // エラーメッセージ表示フラグ
          if ('isErrorMessageShown' in group1) {
            group1.isErrorMessageShown = true
          }

          // エラーメッセージが「お申込みコードの有効期限切れのため再度申請しなおしてください」の場合は画面に表示する
          if (errorMessage.indexOf('有効期限') >= 0) {
            if ('errorMessageDisp' in group1) {
              group1.errorMessageDisp = errorMessage
            }
          }

        }
      }
    })
    .finally(() => {
      store.dispatch('common/hideLoading')
    })

}

/**
 * 利用者の契約情報を表示するために使用するAPIへのリクエスト処理し、
 * その後、引数で渡したコールバック処理を行う
 * @param callback コールバック関数
 * @param changePaymentMethodName 支払い方法名変更フラグ
 */
export const processWithGettingPaymentMethodInfo = (callback, changePaymentMethodName) => {

  const promise1 = new Promise((resolve, reject) => {
    // AG-001 契約情報取得APIをコール
    const paramsContract = {
    }
    apiContract.getContract(paramsContract)
      .then(response => {
        if (response) {
          const { data } = response

          const status = data.status

          if (status === 0) {
            const defaultPayment = data.default_payment

            const map = {
              default_payment: defaultPayment
            }
            const json = JSON.stringify(map)

            resolve(json)
          } else {
            reject(new Error())
          }
        } else {
          reject(new Error())
        }
      })
  })

  const promise2 = new Promise((resolve, reject) => {
    // SN-001 支払い方法取得APIをコール
    const params = {
    }
    apiPayment.fetchPaymentMethod(params)
      .then(response => {
        if (response) {
          const { data } = response

          const status = data.status

          if (status === 0) {

            const list = data.lists

            const map = {}
            for (var i = 0; i < list.length; i++) {
              const id = String(list[i].id)
              const name = list[i].name
              map[id] = name
            }
            const map2 = {
              authorization: data.authorization,
              map: map
            }
            const json = JSON.stringify(map2)
            resolve(json)
          } else {
            reject(new Error())
          }
        } else {
          reject(new Error())
        }
      })
  })

  const promiseList = [promise1, promise2]

  Promise.all(promiseList)
    .then((messages) => {
      // 支払い区分
      const map1 = JSON.parse(messages[0])
      // お支払方法ID
      const paymentMethodID = map1.default_payment
      const paymentMethodIDString = String(paymentMethodID)

      // 支払い方法名マップ
      const map2 = JSON.parse(messages[1])
      const authorization = map2.authorization
      const paymentMethodMap = map2.map

      // 支払い方法名
      let paymentMethodName = paymentMethodMap[paymentMethodIDString]
      
      // 以下を満たす場合は、支払い方法名を「銀行振込」→「銀行振込（WEB請求）」に変更する
      // ・AG-001のレスポンス：default_payment = 7
      // ・SN-001のレスポンス：authorization = true
      // ・SN-010のレスポンス：2のrequest = 1 or 2 or 3, settlement = 9
      if (paymentMethodID === 7 && authorization && changePaymentMethodName) {
        // SN-010 申請情報取得APIをコール
        const identificationCode = store.state.profile.identification_code
        const params2 = {
          identification_code: identificationCode // 契約識別コード
        }
        apiPayment.fetchApplicationInfo(params2)
          .then(response => {
            if (response) {
              const { data } = response

              const status = data.status

              if (status === 0) {

                // リーガルコネクションの申請状況
                const lcResult = data['2']

                // 状態コード (1:受付 2:審査中 3:有効 4:停止 8:却下 9:解約 97:契約削除 98:合併 99:退会)
                // ※審査中は「1:受付 or 2:審査中」、審査完了は「3:有効」である
                const lcRequest = parseInt(lcResult.request)
                // 状態コードをストアに保持
                store.dispatch('payment/setRequest', lcRequest)

                // 決済方法（1:クレジット 2:口座振替 9:WEB請求書発行（銀行振込））
                const lcSettlement = parseInt(lcResult.settlement)

                if ((lcRequest === 1 || lcRequest === 2 || lcRequest === 3) && lcSettlement === 9) {
                  paymentMethodName = '銀行振込（WEB請求）'
                }
              }
            }
          })
          .finally(() => {
            callback(paymentMethodID, paymentMethodName)
          })
      } else {
        callback(paymentMethodID, paymentMethodName)
      }
    })

}

/**
 * 状態コードに対する状態の名称を取得
 * @param {*} lcRequest 
 * @returns 
 */
export const getLCRequestName = (lcRequest) => {
  // 状態コード (1:受付 2:審査中 3:有効 4:停止 8:却下 9:解約 97:契約削除 98:合併 99:退会)
  // ※審査中は「1:受付 or 2:審査中」、審査完了は「3:有効」である
  let name = null
  switch (lcRequest) {
    case 1:
    case 2:
      // 審査中は「1:受付 or 2:審査中」
      name = 'under_exam'
      break

    case 3:
      // 審査完了は「3:有効」である
      name = 'examined'
      break

    default:
      // ここの処理では審査中と審査完了しか使わないので、その他はnullにしておく
      name = null
      break
  }

  return name
}

/**
 * settlementのID体系をpayment_classificationのID体系に変換する
 * ＜settlementのID体系＞
 * settlement: 決済方法（1:クレジット 2:口座振替 9:WEB請求書発行（銀行振込））
 * payment: 支払い方法（クレジットカードの場合のみ　1:一括　2:分割）
 * ＜payment_classificationのID体系＞
 * 1:クレジットカード（一括） 2:クレジットカード（分割）3:口座振替 7:銀行振込
 * ※「コンビニ支払い・郵便振替」はsettlementのID体系には存在しない
 * @param {*} settlement 決済方法ID
 * @param {*} payment クレジットカード以外の場合は無効(未使用)
 */
export const convertSettlementToPaymentClassification = (settlement, payment) => {
  let paymentClassification = 0
  if (settlement === 1 && payment === 1) {
    // クレジットカード（一括）
    paymentClassification = 1
  } else if (settlement === 1 && payment === 2) {
    // クレジットカード（分割）
    paymentClassification = 2
  } else if (settlement === 2) {
    // 口座振替
    paymentClassification = 3
  } else if (settlement === 9) {
    // 銀行振込
    paymentClassification = 7
  }
  return paymentClassification
}

/**
 * 「ご請求案内」画面を使用できるか？
 */
export const isInvoicingInformationAvailable = () => {
  //   自動決済やWEB請求書発行が有効にある前にご請求案内画面に遷移させてはいけない。
  // 「既定のお支払方法」からのリンクやメニューの表示を非表示にする。
  // ※遷移できる条件は、snAdmin側の申請情報の状態が「有効」「停止」「解約予約」「解約」「退会」
  // 　SN010の2.requestが3,4,7,9,99の時のみ表示
  const lcRequest = store.state.payment.request
  let isOK
  switch (lcRequest) {
    case 3:
    case 4:
    case 7:
    case 9:
    case 99:
      // 表示
      isOK = true
      break
    default:
      // 非表示
      isOK = false
      break
  }
  return isOK
}

/**
 * 「WEB請求書発行」が使用できるか？
 * 【用途】
 * 「WEB請求書発行（PDF）を有効にする」の表示判定
 * 「WEB請求書発行」右側の表示文言「申請済み」or「WEB請求書発行サービスをご提供できません。」の判定
 */ 
export const isWebInvoiceIssuanceApprovalAvailable = () => {
  const lcRequest = store.state.payment.request
  let isOK
  switch (lcRequest) {
    case 4:
    case 8:
      // 「4:停止」「8:却下」の場合は非表示
      isOK = false
      break
    default:
      // 表示
      isOK = true
      break
  }
  return isOK
}
